import { render, staticRenderFns } from "./TableComp.vue?vue&type=template&id=23ef5ef3&scoped=true"
import script from "./TableComp.vue?vue&type=script&lang=js"
export * from "./TableComp.vue?vue&type=script&lang=js"
import style0 from "./TableComp.vue?vue&type=style&index=0&id=23ef5ef3&prod&lang=less&scoped=true"
import style1 from "./TableComp.vue?vue&type=style&index=1&id=23ef5ef3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ef5ef3",
  null
  
)

export default component.exports